import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FiPlus } from "react-icons/fi";

import { ItemPagination } from "../../components/ItemPagination";

import { api } from "../../services/api";
import { AuthContext, useAuth } from "../../contexts/AuthContext";
import { PageTitle } from "../../components/PageTitle";
import { EmptyState } from "../../components/EmptyState";
import { CanAccess } from "../../components/CanAccess";

interface Service {
  id: string;
  name: string;
  status: string;
}

export function Services() {
  const { user } = useContext(AuthContext);
  const { hasPermission } = useAuth();
  const [services, setServices] = useState<Service[]>([]);
  const [changeStatus, setChangeStatus] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api
      .get("/services")
      .then(response => {
        setServices(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        navigate("/signin");
      });
  }, [changeStatus]);

  async function handleChangeStatus(id: string, newStatus: string) {
    api.patch(`services/status/${id}/${newStatus === "A" ? "I" : "A"}`);
    setTimeout(() => {
      setChangeStatus(changeStatus + 1);
    }, 1000);
  }

  return (
    <div className="container mx-auto">
      <PageTitle title="Serviços" backButton backPath="/home" />
      <div className="flex items-start justify-between mb-6">
        <CanAccess permission="services:create" allowAdmin>
          <Link
            to="/services/new"
            className="group bg-[#0085BD] text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
          >
            <FiPlus size={24} className="transition-transform duration-200 group-hover:rotate-90" />
          </Link>
        </CanAccess>
      </div>
      <div className="space-y-2">
        {loading && (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0085BD]" />
          </div>
        )}
        {!loading &&
          services.length > 0 &&
          services.map(({ id, name, status }: Service) => (
            <ItemPagination
              key={id}
              title={name}
              id={id}
              status={status}
              hasDelete
              canEdit={hasPermission("services:update")}
              canDelete={hasPermission("services:delete")}
              handleChangeStatus={() => handleChangeStatus(id, status)}
            />
          ))}
        {!loading && services.length === 0 && (
          <div className="col-span-full">
            <EmptyState type="services" />
          </div>
        )}
      </div>
    </div>
  );
}
